import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      soundVolume: state => state.soundVolume
    })
  },

  data() {
    return {
      interval: null
    };
  },

  methods: {
    scrubAudio(audio, captionObj) {
      const self = this;
      const getTimeStamp = function isPlaying() {
        if (audio.playing()) {
          const timeStamp = audio.seek();
          self.syncAudioWithCaption(parseFloat(timeStamp.toFixed(1)), captionObj);
          setTimeout(isPlaying, 100);
        }
      };

      audio.on('play', () => getTimeStamp(audio, captionObj));
    },
    syncAudioWithCaption(audioTimeStamp, captionObj) {
      const subtitle = captionObj.find(
        ({ start }) => this.formatTimeStamp(start, 1) === audioTimeStamp
      );
      if (subtitle) {
        const { start, end, payload } = subtitle;
        clearInterval(this.interval);
        this.caption = payload;
        this.interval = setTimeout(() => {
          this.caption = '';
        }, (this.formatTimeStamp(end, 1) - this.formatTimeStamp(start, 1)) * 1500);
      }
    },
    formatTimeStamp(time, digits) {
      const [h, m, s] = time.split(':');
      const timeStamp = parseFloat(h * 3600 + m * 60 + s * 1).toFixed(digits);
      return parseFloat(timeStamp);
    }
  }
};
